import api from '@/services/api';
import { BaseService } from './base.service';

export class EmergencyInfoService extends BaseService {
  constructor() {
    super('/emergency-info');
  }

  async updateEmergencyInfo(memberId: string, payload: any) {
    if (!memberId) throw new Error('Member ID is required');
    // Always use PUT for updates
    return api.put(`/emergency-info/${memberId}`, payload).then(res => res.data);
  }

  async getEmergencyInfo(memberId: string) {
    if (!memberId) throw new Error('Member ID is required');
    return api.get(`/emergency-info/${memberId}`).then(res => res.data);
  }

  async downloadEmergencyCardPdf(memberId: string) {
    if (!memberId) throw new Error('Member ID is required');
    return api.get(`/emergency-info/${memberId}/pdf`, {
      responseType: 'blob',
    }).then(res => res.data);
  }
}

export const emergencyInfoService = new EmergencyInfoService();
